import { render, staticRenderFns } from "./LightDetail.vue?vue&type=template&id=2eb65277&"
import script from "./LightDetail.vue?vue&type=script&lang=ts&"
export * from "./LightDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports